import { newProductPlanTypes } from "redux/Ldb/types/newProductPlanTypes";

const initialState = {
    // Single new product plan
    fetchingSingleNewProductPlan: false,
    fetchedSingleNewProductPlanSuccess: null,
    fetchedSingleNewProductPlanFailure: null,

    // New product plans list
    fetchingNewProductPlans: false,
    fetchedNewProductPlansSuccess: null,
    fetchedNewProductPlansFailure: null,

    // Create new product plan
    creatingNewProductPlan: false,
    createdNewProductPlanSuccess: null,
    createdNewProductPlanFailure: null,

    // Update new product plan
    updatingNewProductPlan: false,
    updatedNewProductPlanSuccess: null,
    updatedNewProductPlanFailure: null,

    // Pin new product plan
    pinningNewProductPlan: false,
    pinnedNewProductPlanSuccess: null,
    pinnedNewProductPlanFailure: null,

    // Unpin new product plan
    unpinningNewProductPlan: false,
    unpinnedNewProductPlanSuccess: null,
    unpinnedNewProductPlanFailure: null,

    // Cancel new product plan
    cancelingNewProductPlan: false,
    canceledNewProductPlanSuccess: null,
    canceledNewProductPlanFailure: null,

    // Delete new product plan
    deletingNewProductPlan: false,
    deletedNewProductPlanSuccess: null,
    deletedNewProductPlanFailure: null,
};

export const newProductPlan = (state = initialState, action: { type: string; payload: any }) => {
    switch (action.type) {
        // Single new product plan
        case newProductPlanTypes.FETCH_SINGLE_NEW_PRODUCT_PLAN_REQUEST:
            return {
                ...state,
                fetchingSingleNewProductPlan: true,
                fetchedSingleNewProductPlanSuccess: null,
                fetchedSingleNewProductPlanFailure: null,
            };
        case newProductPlanTypes.FETCH_SINGLE_NEW_PRODUCT_PLAN_SUCCESS:
            return {
                ...state,
                fetchingSingleNewProductPlan: false,
                fetchedSingleNewProductPlanSuccess: action.payload,
                fetchedSingleNewProductPlanFailure: null,
            };
        case newProductPlanTypes.FETCH_SINGLE_NEW_PRODUCT_PLAN_FAILURE:
            return {
                ...state,
                fetchingSingleNewProductPlan: false,
                fetchedSingleNewProductPlanSuccess: null,
                fetchedSingleNewProductPlanFailure: action.payload,
            };

        // New product plans list
        case newProductPlanTypes.FETCH_NEW_PRODUCT_PLANS_REQUEST:
            return {
                ...state,
                fetchingNewProductPlans: true,
                fetchedNewProductPlansSuccess: null,
                fetchedNewProductPlansFailure: null,
            };
        case newProductPlanTypes.FETCH_NEW_PRODUCT_PLANS_SUCCESS:
            return {
                ...state,
                fetchingNewProductPlans: false,
                fetchedNewProductPlansSuccess: action.payload,
                fetchedNewProductPlansFailure: null,
            };
        case newProductPlanTypes.FETCH_NEW_PRODUCT_PLANS_FAILURE:
            return {
                ...state,
                fetchingNewProductPlans: false,
                fetchedNewProductPlansSuccess: null,
                fetchedNewProductPlansFailure: action.payload,
            };

        // Create new product plan
        case newProductPlanTypes.CREATE_NEW_PRODUCT_PLAN_REQUEST:
            return {
                ...state,
                creatingNewProductPlan: true,
                createdNewProductPlanSuccess: null,
                createdNewProductPlanFailure: null,
            };
        case newProductPlanTypes.CREATE_NEW_PRODUCT_PLAN_SUCCESS:
            return {
                ...state,
                creatingNewProductPlan: false,
                createdNewProductPlanSuccess: action.payload,
                createdNewProductPlanFailure: null,
            };
        case newProductPlanTypes.CREATE_NEW_PRODUCT_PLAN_FAILURE:
            return {
                ...state,
                creatingNewProductPlan: false,
                createdNewProductPlanSuccess: null,
                createdNewProductPlanFailure: action.payload,
            };

        // Update new product plan
        case newProductPlanTypes.UPDATE_NEW_PRODUCT_PLAN_REQUEST:
            return {
                ...state,
                updatingNewProductPlan: true,
                updatedNewProductPlanSuccess: null,
                updatedNewProductPlanFailure: null,
            };
        case newProductPlanTypes.UPDATE_NEW_PRODUCT_PLAN_SUCCESS:
            return {
                ...state,
                updatingNewProductPlan: false,
                updatedNewProductPlanSuccess: action.payload,
                updatedNewProductPlanFailure: null,
            };
        case newProductPlanTypes.UPDATE_NEW_PRODUCT_PLAN_FAILURE:
            return {
                ...state,
                updatingNewProductPlan: false,
                updatedNewProductPlanSuccess: null,
                updatedNewProductPlanFailure: action.payload,
            };

        // Pin new product plan
        case newProductPlanTypes.PIN_NEW_PRODUCT_PLAN_REQUEST:
            return {
                ...state,
                pinningNewProductPlan: true,
                pinnedNewProductPlanSuccess: null,
                pinnedNewProductPlanFailure: null,
            };
        case newProductPlanTypes.PIN_NEW_PRODUCT_PLAN_SUCCESS:
            return {
                ...state,
                pinningNewProductPlan: false,
                pinnedNewProductPlanSuccess: action.payload,
                pinnedNewProductPlanFailure: null,
            };
        case newProductPlanTypes.PIN_NEW_PRODUCT_PLAN_FAILURE:
            return {
                ...state,
                pinningNewProductPlan: false,
                pinnedNewProductPlanSuccess: null,
                pinnedNewProductPlanFailure: action.payload,
            };

        // Unpin new product plan
        case newProductPlanTypes.UNPIN_NEW_PRODUCT_PLAN_REQUEST:
            return {
                ...state,
                unpinningNewProductPlan: true,
                unpinnedNewProductPlanSuccess: null,
                unpinnedNewProductPlanFailure: null,
            };
        case newProductPlanTypes.UNPIN_NEW_PRODUCT_PLAN_SUCCESS:
            return {
                ...state,
                unpinningNewProductPlan: false,
                unpinnedNewProductPlanSuccess: action.payload,
                unpinnedNewProductPlanFailure: null,
            };
        case newProductPlanTypes.UNPIN_NEW_PRODUCT_PLAN_FAILURE:
            return {
                ...state,
                unpinningNewProductPlan: false,
                unpinnedNewProductPlanSuccess: null,
                unpinnedNewProductPlanFailure: action.payload,
            };

        // Cancel new product plan
        case newProductPlanTypes.CANCEL_NEW_PRODUCT_PLAN_REQUEST:
            return {
                ...state,
                cancelingNewProductPlan: true,
                canceledNewProductPlanSuccess: null,
                canceledNewProductPlanFailure: null,
            };
        case newProductPlanTypes.CANCEL_NEW_PRODUCT_PLAN_SUCCESS:
            return {
                ...state,
                cancelingNewProductPlan: false,
                canceledNewProductPlanSuccess: action.payload,
                canceledNewProductPlanFailure: null,
            };
        case newProductPlanTypes.CANCEL_NEW_PRODUCT_PLAN_FAILURE:
            return {
                ...state,
                cancelingNewProductPlan: false,
                canceledNewProductPlanSuccess: null,
                canceledNewProductPlanFailure: action.payload,
            };

        // Delete new product plan
        case newProductPlanTypes.DELETE_NEW_PRODUCT_PLAN_REQUEST:
            return {
                ...state,
                deletingNewProductPlan: true,
                deletedNewProductPlanSuccess: null,
                deletedNewProductPlanFailure: null,
            };
        case newProductPlanTypes.DELETE_NEW_PRODUCT_PLAN_SUCCESS:
            return {
                ...state,
                deletingNewProductPlan: false,
                deletedNewProductPlanSuccess: action.payload,
                deletedNewProductPlanFailure: null,
            };
        case newProductPlanTypes.DELETE_NEW_PRODUCT_PLAN_FAILURE:
            return {
                ...state,
                deletingNewProductPlan: false,
                deletedNewProductPlanSuccess: null,
                deletedNewProductPlanFailure: action.payload,
            };

        // Reset actions
        case newProductPlanTypes.RESET_FETCH_SINGLE_NEW_PRODUCT_PLAN:
            return {
                ...state,
                fetchingSingleNewProductPlan: false,
                fetchedSingleNewProductPlanSuccess: null,
                fetchedSingleNewProductPlanFailure: null,
            };
        case newProductPlanTypes.RESET_FETCH_NEW_PRODUCT_PLANS:
            return {
                ...state,
                fetchingNewProductPlans: false,
                fetchedNewProductPlansSuccess: null,
                fetchedNewProductPlansFailure: null,
            };
        case newProductPlanTypes.RESET_CREATE_NEW_PRODUCT_PLAN:
            return {
                ...state,
                creatingNewProductPlan: false,
                createdNewProductPlanSuccess: null,
                createdNewProductPlanFailure: null,
            };
        case newProductPlanTypes.RESET_UPDATE_NEW_PRODUCT_PLAN:
            return {
                ...state,
                updatingNewProductPlan: false,
                updatedNewProductPlanSuccess: null,
                updatedNewProductPlanFailure: null,
            };
        case newProductPlanTypes.RESET_PIN_NEW_PRODUCT_PLAN:
            return {
                ...state,
                pinningNewProductPlan: false,
                pinnedNewProductPlanSuccess: null,
                pinnedNewProductPlanFailure: null,
            };
        case newProductPlanTypes.RESET_UNPIN_NEW_PRODUCT_PLAN:
            return {
                ...state,
                unpinningNewProductPlan: false,
                unpinnedNewProductPlanSuccess: null,
                unpinnedNewProductPlanFailure: null,
            };
        case newProductPlanTypes.RESET_CANCEL_NEW_PRODUCT_PLAN:
            return {
                ...state,
                cancelingNewProductPlan: false,
                canceledNewProductPlanSuccess: null,
                canceledNewProductPlanFailure: null,
            };
        case newProductPlanTypes.RESET_DELETE_NEW_PRODUCT_PLAN:
            return {
                ...state,
                deletingNewProductPlan: false,
                deletedNewProductPlanSuccess: null,
                deletedNewProductPlanFailure: null,
            };

        default:
            return state;
    }
};
